import { CreateAssistantData, UpdateAssistantData } from '@/types/assistants';
import api from './client';


export const assistantApi = {
    create: (data: CreateAssistantData) =>
        api.post('/assistants', data),

    getOne: (id: number) =>
        api.get(`/assistant/${id}`, ),

    getAll: () =>
        api.get('/assistants', { data: {} }), // Empty data object to match API docs

    update: (data: UpdateAssistantData) =>
        api.put('/assistants', data),

    delete: (id: number) =>
        api.delete('/assistants', { data: { id } }),
};

